import { render } from "./SocialTrend.vue?vue&type=template&id=af5fbb1e&scoped=true"
import script from "./SocialTrend.vue?vue&type=script&lang=js"
export * from "./SocialTrend.vue?vue&type=script&lang=js"

import "./SocialTrend.vue?vue&type=style&index=0&id=af5fbb1e&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af5fbb1e"]])

export default __exports__